<div class="docToast">
  @for (toast of toastService.toasts(); track toast) {
  <ngb-toast [class]="toast.classname" [autohide]="true" [delay]="toast.delay" (hidden)="toastService.remove(toast)">
    {{ toast.message }}
  </ngb-toast>
  }

</div>